<template>
  <div id="app">
    <Nav  v-if="showNav"></Nav>
    <router-view/>
    <Footer  v-if="showFooter"></Footer>
  </div>
</template>

<script>
import Nav from "@/layouts/nav.vue"
import Footer from '@/layouts/footer.vue'


export default {
  name: 'App',
  components: {
    Nav,
    Footer
  },
  data() {
    return {
      showNav: true,
      showFooter: true
    };
  },
  watch: {
    $route(to, from) {
      // Update component visibility based on the route
      this.updateComponentVisibility();
    }
  },
  methods: {
    updateComponentVisibility() {
      // Check if the current route is the login page
      const isLoginPage = this.$route.name === 'login'; // Adjust the route name as per your setup

      // Update component visibility based on the route
      this.showNav = !isLoginPage;
      this.showFooter = !isLoginPage;
    }
  },
  beforeMount() {
    // Set initial component visibility
    this.updateComponentVisibility();
  }
}
</script>
<style lang="less">
*, html, body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body, #app {
  height: 100%;
  margin: 0;
  overflow-x: hidden;
}

#app {
  display: flex;
  flex-direction: column;
}

.router-view {
  flex: 1;
}

</style>
